
import React from "react";
import {ISupportedPlatformsWrapper} from "../interfaces";
import CheckIcon from "../../../../ui/svg/common/check-v";
import {useAppSelector} from "../../product-page/data-services/store";
import SearchFilter from "./search-filter";
import {ProductTypeEnum} from "../../product-page/data-services/data-service";


export interface ISupportedPlatformsProps {
    supportedPlatformsWrapper?:ISupportedPlatformsWrapper
}
/**
 * the entry point
 */
const TabSupportedPlatforms = (props?: ISupportedPlatformsProps) => {

    const techSpecsSearchPlugins = useAppSelector((store) => store.techSpecsSearchPlugins);
    const productDataType = useAppSelector((store) => store.productDataType);
    const supportedPlatformsWrapper = props?.supportedPlatformsWrapper;

    const checkIcon =  <CheckIcon width="14" height="10" color="1D1D1D"  />
    console.log('supportedPlatforms: ',supportedPlatformsWrapper?.supportedPlatforms);
    return (
        <div className="my-4">
            {supportedPlatformsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: supportedPlatformsWrapper?.topBanner }} />}
            {supportedPlatformsWrapper != null && supportedPlatformsWrapper.supportedPlatforms.length > 0 &&
                <table className="table-fixed w-full text-base mt-8 rounded">
                <thead style={{position:productDataType !== ProductTypeEnum.plugin ? "sticky" : "unset",top:(supportedPlatformsWrapper.topPosition && supportedPlatformsWrapper.topPosition !== null) ? supportedPlatformsWrapper.topPosition : "136px"}}>
                {productDataType !== ProductTypeEnum.plugin &&  <tr>
                    <td className="bg-white" colSpan={10} >
                        <SearchFilter />
                    </td>
                </tr>}
                <tr className="h-20 bg-gray-150">
                    <td className="font-bold border pl-4">Plugin</td>
                    <td className="font-bold border text-center-webkit px-1">Most Audio Hosts*</td>
                    <td className="font-bold border text-center-webkit px-1">StudioVerse</td>
                    <td className="font-bold border text-center-webkit px-1">SuperRack</td>
                    <td className="font-bold border text-center-webkit px-1">eMotion LV1 Mixer</td>
                    <td className="font-bold border text-center-webkit px-1">eMotion ST Mixer</td>
                    <td className="font-bold border text-center-webkit px-1">StudioRack**</td>
                    <td className="font-bold border text-center-webkit px-1">MultiRack***</td>
                    <td className="font-bold border text-center-webkit px-1">DiGiCo****</td>
                    <td className="font-bold border text-center-webkit px-1">Avid VENUE 7.1 or later*****</td>
                </tr>
                </thead>
                    <tbody>
                    {
                        supportedPlatformsWrapper?.supportedPlatforms?.filter(s=>s.documentName.toLowerCase().includes(techSpecsSearchPlugins.toLowerCase())).map((sp, index) => {
                        return (
                            <tr key={index}
                                className="w-full h-20">
                                <td className="border pl-4">{sp.documentName}</td>
                                <td className="border text-center-webkit">{sp.mostAudioHosts ? checkIcon : ""}</td>
                                <td className="border text-center-webkit">
                                    {(sp.studioVerseAudioEffects && sp.studioVerseInstruments) && checkIcon}
                                    {(!sp.studioVerseAudioEffects && !sp.studioVerseInstruments) && ""}
                                    {(sp.studioVerseAudioEffects && !sp.studioVerseInstruments) &&
                                        <div>{checkIcon} <span className="text-sm text-gray-400">StudioVerse Audio Effects Only</span>
                                        </div>}
                                    {(!sp.studioVerseAudioEffects && sp.studioVerseInstruments) &&
                                        <div>{checkIcon} <span className="text-sm text-gray-400">StudioVerse Instruments Only</span>
                                        </div>}
                                </td>
                                <td className="border text-center-webkit">

                                    {(sp.superRackNative && sp.superRackSoundGrid) && checkIcon}
                                    {(!sp.superRackNative && !sp.superRackSoundGrid) && ""}
                                    {(sp.superRackNative && !sp.superRackSoundGrid) &&
                                        <div>{checkIcon} <span className="text-sm text-gray-400">SuperRack Performer Only</span></div>}
                                </td>
                                <td className="border text-center-webkit">
                                    {(sp.eMotionLV1Mixer && sp.eMotionLV1Classic) ? checkIcon : ""}
                                    {
                                        (sp.eMotionLV1Mixer && !sp.eMotionLV1Classic) &&
                                        <div>{checkIcon} <span className="text-sm text-gray-400">Not supported on LV1 Classic</span></div>
                                    }
                                </td>
                                <td className="border text-center-webkit">{sp.eMotionSTMixer ? checkIcon : ""}</td>
                                <td className="border text-center-webkit">

                                    {(sp.studioRackNative && sp.studioRackSoundGrid) && checkIcon}
                                    {(!sp.studioRackNative && !sp.studioRackSoundGrid) && ""}
                                    {(sp.studioRackNative && !sp.studioRackSoundGrid) &&
                                        <div>{checkIcon} <span className="text-sm text-gray-400">StudioRack Native Only</span>
                                        </div>}
                                </td>
                                <td className="border text-center-webkit">
                                    {(sp.multiRackNative && sp.multiRackSoundGrid) && checkIcon}
                                    {(!sp.multiRackNative && !sp.multiRackSoundGrid) && ""}
                                    {(sp.multiRackNative && !sp.multiRackSoundGrid) &&
                                        <div>{checkIcon} <span className="text-sm text-gray-400">MultiRack Native Only</span>
                                        </div>}
                                </td>
                                <td className="border text-center-webkit">{sp.diGiCo ? checkIcon : ""}</td>
                                <td className="border text-center-webkit">{sp.venue ? checkIcon : ""}</td>
                            </tr>
                        )
                        })
                    }
                    </tbody>
                </table>}
            {/*<div className="mt-4" ><p className="tab-supported-platforms-comment">
                <a className="cursor-pointer" href={_hrefVoid}
                   onClick={ evt => {
                       evt.preventDefault();
                       dispatch(rootActions.main({techSpecsSelectedTab: 'tab-supported-hosts', techSpecsRefreshHash:true}));}}
                >*Check the Supported Hosts tab for more info.</a>
                <br />
                **DiGiCo SD (v929 or earlier) with MultiRack (v9.8 or earlier) embedded.
                <br />
                ***When used with <a href="/mixers-racks/soundgrid-rack-for-venue">SoundGrid Rack  for VENUE</a>.</p>
            </div>*/}
            {supportedPlatformsWrapper != null &&
                <div className={"my-8"} dangerouslySetInnerHTML={{ __html: supportedPlatformsWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabSupportedPlatforms;